
class SubCategory{
    constructor(id, name, models = []) {
        this.id = id;
        this.name = name;
        this.models = models;
      }
}

export default SubCategory;